import {TaskDto} from './TaskDto';

export class SaveGanttChartInfoDto {
    constructor(public Version, public SubTableView: string, public ResourcesView: string, public Tasks: TaskDto[]) {
    }
}